// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';

import Radio from './elements/Radio';
import { Checkbox } from './elements/Checkbox';
import Switch from './elements/Switch';
import ButtonGroup from './elements/ButtonGroup';
import { Menu } from './elements/Menu';
import Input from './elements/Input';
import InputNumber from './elements/InputNumber';
import Button from './elements/Button';
import SidePanel from './elements/SidePanel';
import DatePicker from './elements/DatePicker';
import TimePicker from './elements/TimePicker';
import { FileUpload } from './elements/FileUpload';
import Banner from './elements/Banner';
import Title from './elements/typography/Title';
import { Table } from './elements/Table';
import P from './elements/typography/P';
import Text from './elements/typography/Text';
import DateRangePicker from './elements/DateRangePicker';
import Link from './elements/Link';
import IconButton from './elements/IconButton';
import TextArea from './elements/TextArea';
import { Steps } from './elements/Steps';
import Tooltip from './elements/Tooltip';
import TimeRangePicker from './elements/TimeRangePicker';
import { Skeleton } from './elements/Skeleton';
import {
  DeleteOutlined,
  DownloadOutlined,
  LoadingOutlined,
  LogoutOutlined,
  PauseCircleOutlined,
  PhoneOutlined,
  PlayCircleOutlined,
  PlusOutlined,
  InfoCircleOutlined,
  QuestionCircleOutlined,
  UploadOutlined,
  UserOutlined,
  WalletOutlined,
  PaperClipOutlined,
  ClockCircleOutlined,
  StopOutlined,
  CopyOutlined,
  EditOutlined,
  SearchOutlined,
  FilterOutlined,
  CloseOutlined,
  CheckOutlined,
  CalendarOutlined,
  TagOutlined,
  AppstoreAddOutlined,
  SettingOutlined,
  PoweroffOutlined,
  ReloadOutlined,
  RightOutlined,
  LeftOutlined,
  MessageFilled,
  MinusCircleOutlined,
  CheckCircleOutlined,
  CheckCircleFilled,
  MinusCircleFilled,
  PauseCircleFilled,
  PauseOutlined,
  CaretRightOutlined,
  BackwardOutlined,
  ForwardOutlined,
  SoundOutlined,
  MinusOutlined,
  IdcardOutlined,
  WarningOutlined,
  LineChartOutlined,
  SyncOutlined,
  FieldTimeOutlined,
  SelectOutlined,
  MoreOutlined,
  PieChartOutlined,
  ExclamationCircleFilled,
  CloseCircleFilled,
  EyeFilled,
  DownOutlined,
  UpOutlined,
  EyeOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  ArrowRightOutlined,
  SwapOutlined,
  MailOutlined,
  TeamOutlined,
  BoldOutlined,
  ItalicOutlined,
  UnderlineOutlined,
  StrikethroughOutlined,
  OrderedListOutlined,
  UnorderedListOutlined,
  AlignLeftOutlined,
  AlignCenterOutlined,
  AlignRightOutlined,
  UndoOutlined,
  RedoOutlined,
  LinkOutlined,
  DisconnectOutlined,
  PictureOutlined,
  DeploymentUnitOutlined,
  LockOutlined,
  BankOutlined,
  MenuOutlined,
  CreditCardOutlined,
  ProductOutlined,
  CustomerServiceOutlined,
  BarChartOutlined,
  AudioOutlined,
  AppstoreOutlined,
  GoldOutlined,
  FormOutlined,
  ContainerOutlined,
  BellOutlined,
  BellFilled,
  CommentOutlined,
  SafetyOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  CrownOutlined,
  LoginOutlined,
  RetweetOutlined,
  MessageOutlined,
  MacCommandOutlined,
  DashboardOutlined,
  QrcodeOutlined,
  ExpandAltOutlined,
  AudioMutedOutlined,
} from '@ant-design/icons';
import AudioPlayer from './elements/AudioPlayer';
import Collapse from './elements/Collapse';
import Modal from './elements/Modal';
import { Select, SelectOptionView } from './elements/Select';
import MultiSelect from './elements/MultiSelect';
import { FormItem } from './elements/LabeledFormItem';
import { Validation } from './elements/Validation';
import { SelectOption } from './elements/SelectOption';
import { FileUploadDragger } from './elements/FileUploadDragger';
import { Loader } from './elements/Loader';
import { CheckboxGroup } from './elements/CheckboxGroup';
import { Dropdown } from './elements/Dropdown';
import { Tag } from './elements/Tag';
import { CheckableTagGroup } from './elements/CheckableTagGroup';
import { CalendarRangePicker } from './elements/CalendarRangePicker';
import { Divider } from './elements/Divider';
import { ScrollableList } from './elements/ScrollableList';
import { SkeletonLoader } from './elements/SkeletonLoader';
import ListItemSelection from './elements/ListItemSelection';
import NewMultiSelect from './elements/NewMultiSelect';
import { Pagination } from './elements/Pagination';
import { RadioGroup } from './elements/RadioGroup';
import { FlowChart } from './elements/FlowChart';
import { DropdownButton } from './elements/DropdownButton';
import { TableMultiSelectFilter } from './elements/table-filters/MultiSelect';
import { TextEditor } from './elements/TextEditor';
import { LineChart } from './elements/charts/LineChart';
import SegmentedSwitcher from './elements/SegmentedSwitcher';
import { Card } from './elements/Card';
import { TreeSelect } from './elements/TreeSelect';
import { HTMLViewer } from './elements/HTMLViewer';
import { useNotification } from './elements/hooks/useNotifications';
import { AppProvider } from './elements/AppProvider';
import { useModal } from './elements/hooks/useModal';
import { Progress } from './elements/Progress';
import { Tabs } from './elements/Tabs';
import Slider from './elements/Slider';
import { SideLayout } from './elements/SideLayout';
import { SideMenu } from './elements/SideMenu';
import { Carousel } from './elements/Carousel';
import { Spin } from './elements/Spin';

const hooks = {
  useNotification,
  useModal,
};

const charts = {
  LineChart: LineChart,
};

const form = {
  Item: FormItem,
  Validation,
};

const icons = {
  IDCard: IdcardOutlined,
  PowerOff: PoweroffOutlined,
  Settings: SettingOutlined,
  Search: SearchOutlined,
  Filter: FilterOutlined,
  Wallet: WalletOutlined,
  User: UserOutlined,
  Phone: PhoneOutlined,
  Mail: MailOutlined,
  Exit: LogoutOutlined,
  Upload: UploadOutlined,
  DownLoad: DownloadOutlined,
  Loading: LoadingOutlined,
  Warning: WarningOutlined,
  PlayCircle: PlayCircleOutlined,
  PauseCircle: PauseCircleOutlined,
  Pause: PauseOutlined,
  CaretRight: CaretRightOutlined,
  Backward: BackwardOutlined,
  Forward: ForwardOutlined,
  Sound: SoundOutlined,
  Check: CheckOutlined,
  Minus: MinusOutlined,
  PauseCircleFilled: PauseCircleFilled,
  CheckCircle: CheckCircleOutlined,
  CheckCircleFilled: CheckCircleFilled,
  MessageFilled: MessageFilled,
  ArrowUp: ArrowUpOutlined,
  ArrowDown: ArrowDownOutlined,
  ArrowRight: ArrowRightOutlined,
  Swap: SwapOutlined,
  MinusCircle: MinusCircleOutlined,
  MinusCircleFilled: MinusCircleFilled,
  Delete: DeleteOutlined,
  Copy: CopyOutlined,
  Edit: EditOutlined,
  InfoCircle: InfoCircleOutlined,
  QuestionCircle: QuestionCircleOutlined,
  Plus: PlusOutlined,
  Down: DownOutlined,
  Up: UpOutlined,
  PaperClip: PaperClipOutlined,
  Clock: ClockCircleOutlined,
  Lock: LockOutlined,
  Stop: StopOutlined,
  Close: CloseOutlined,
  Tag: TagOutlined,
  AppAdd: AppstoreAddOutlined,
  Calendar: CalendarOutlined,
  Reload: ReloadOutlined,
  Right: RightOutlined,
  Left: LeftOutlined,
  LineChart: LineChartOutlined,
  Sync: SyncOutlined,
  FieldTime: FieldTimeOutlined,
  Select: SelectOutlined,
  More: MoreOutlined,
  PieChart: PieChartOutlined,
  Exclamation: ExclamationCircleFilled,
  CloseCircleFilled: CloseCircleFilled,
  Eye: EyeOutlined,
  Team: TeamOutlined,
  Bold: BoldOutlined,
  Italic: ItalicOutlined,
  Underline: UnderlineOutlined,
  Strikethrough: StrikethroughOutlined,
  OrderedList: OrderedListOutlined,
  UnorderedList: UnorderedListOutlined,
  AlignLeft: AlignLeftOutlined,
  AlignCenter: AlignCenterOutlined,
  AlignRight: AlignRightOutlined,
  Undo: UndoOutlined,
  Redo: RedoOutlined,
  Link: LinkOutlined,
  Disconnect: DisconnectOutlined,
  Picture: PictureOutlined,
  Deployment: DeploymentUnitOutlined,
  Bank: BankOutlined,
  Menu: MenuOutlined,
  CreditCard: CreditCardOutlined,
  Product: ProductOutlined,
  CustomerService: CustomerServiceOutlined,
  BarChart: BarChartOutlined,
  Audio: AudioOutlined,
  Appstore: AppstoreOutlined,
  Gold: GoldOutlined,
  Form: FormOutlined,
  Container: ContainerOutlined,
  Bell: BellOutlined,
  BellFilled: BellFilled,
  Comment: CommentOutlined,
  Safety: SafetyOutlined,
  MenuFold: MenuFoldOutlined,
  MenuUnfold: MenuUnfoldOutlined,
  Crown: CrownOutlined,
  Login: LoginOutlined,
  Retweet: RetweetOutlined,
  MessageOutlined: MessageOutlined,
  CommandOutlined: MacCommandOutlined,
  Dashboard: DashboardOutlined,
  InfoCircleOutlined: InfoCircleOutlined,
  QrcodeOutlined: QrcodeOutlined,
  ExpandAlt: ExpandAltOutlined,
  AudioMuted: AudioMutedOutlined,
};

const UK = {
  Card,
  Radio,
  Checkbox,
  TreeSelect,
  Switch,
  ButtonGroup,
  SegmentedSwitcher,
  Menu,
  Banner,
  Dropdown,
  DropdownButton,
  FileUpload,
  FileUploadDragger,
  Table,
  Pagination,
  Skeleton,
  SkeletonLoader,
  ScrollableList,
  ListItemSelection,
  TextArea,
  Input,
  TableMultiSelectFilter,
  InputNumber,
  CalendarRangePicker,
  Link,
  Steps,
  Progress,
  Tabs,
  SidePanel,
  DatePicker,
  TimePicker,
  FormItem,
  FlowChart,
  Select,
  SelectOption,
  TextEditor,
  SelectOptionView,
  MultiSelect,
  NewMultiSelect,
  Tooltip,
  Modal,
  Button,
  Text,
  IconButton,
  DateRangePicker,
  TimeRangePicker,
  Title,
  P,
  Tag,
  CheckableTagGroup,
  Collapse,
  CheckboxGroup,
  RadioGroup,
  AudioPlayer,
  Divider,
  Loader,
  HTMLViewer,
  AppProvider,
  Slider,
  SideLayout,
  SideMenu,
  icons,
  form,
  charts,
  hooks,
  Carousel,
  Spin,
};

export default UK;
